<template>
  <div class="privacy_policy">
    <div class="title">
      <span>隐私政策</span>
    </div>
    <div class="con">
      <h3>权利声明</h3>
      <hr />
      <p>
        除非专门说明，所有内容版权归三棵树涂料股份有限公司所有。保留所有权利。
        网站内容中提到的其它公司名称、商标和服务为各自公司的注册商标，归各公司所有。三棵树涂料股份有限公司或其控股或参股公司的（注册）商标。
        本网站（包括下属公司网站）的资料、信息、版面设计、图案、流程、声音、程序及其他内容的所有权、著作权及其他权利由三棵树涂料股份有限公司所享有并予以保留，此种权利受到《中华人民共和国民法通则》、《中华人民共和国著作权法》、《中华人民共和国反不正当竞争法》及其他法律、法规、规范性法律文件及相关国际条约的保护，任何对上述权利的侵犯均有可能导致承担民事、行政或刑事责任。使用网站所提供的软件或驱动程序要服从三棵树涂料股份有限公司随产品所附许可证协议规定。
        未经三棵树涂料股份有限公司明确同意，严禁擅自复制和散发莆田三棵树涂料股份有限公司网站资料，违者将受到民事和刑事处分。如想复制或散发本网站明示不可复制或散发的资料，请向三棵树涂料股份有限公司法律部提出书面申请，地址是：福建省莆田市荔园北大道518号。
        在访问我们的网站时，请遵循适用法律的规定。
      </p>
      <h3>网站回复</h3>
      <hr />
      <p>
        除非专门说明，所有内容版权归三棵树涂料股份有限公司所有。保留所有权利。
        网站内容中提到的其它公司名称、商标和服务为各自公司的注册商标，归各公司所有。三棵树涂料股份有限公司或其控股或参股公司的（注册）商标。
        本网站（包括下属公司网站）的资料、信息、版面设计、图案、流程、声音、程序及其他内容的所有权、著作权及其他权利由三棵树涂料股份有限公司所享有并予以保留，此种权利受到《中华人民共和国民法通则》、《中华人民共和国著作权法》、《中华人民共和国反不正当竞争法》及其他法律、法规、规范性法律文件及相关国际条约的保护，任何对上述权利的侵犯均有可能导致承担民事、行政或刑事责任。使用网站所提供的软件或驱动程序要服从三棵树涂料股份有限公司随产品所附许可证协议规定。
        未经三棵树涂料股份有限公司明确同意，严禁擅自复制和散发三棵树涂料股份有限公司网站资料，违者将受到民事和刑事处分。如想复制或散发本网站明示不可复制或散发的资料，请向三棵树涂料股份有限公司法律部提出书面申请，地址是：福建省莆田市荔园北大道518号。
        在访问我们的网站时，请遵循适用法律的规定。
      </p>
      <h3>服务条款</h3>
      <hr />
      <p>
        1）
        本网站所有信息和软件均按现状提供，不带有任何明示或暗示的担保或条件，包括但不限于准确性、及时性和非侵权的默示担保或保证。<br />
        2）
        本网站仅提供相关的网络内容服务，对于可能产生的网络资费由电信运营商收取。<br />
        3）
        本网站引用或链接的信息均为用户提供方便服务而设，所链接网站、网站上的内容及其描述或提供的产品与服务均不受三棵树涂料股份有限公司的控制，因此三棵树涂料股份有限公司不对任何该等网站及其上的内容、产品或服务（包括对第三方网站的进一步链接）负责，如用户选择使用该第三方网站，需承担由此带来的全部后果和风险。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang='less' scoped>
.privacy_policy {
  width: 100%;
  max-width: 800px;
  margin: 10px auto;
  text-align: left;
  .title {
    font-size: 32px;
    font-weight: 600;
    color: #008c3f;
  }
  .con {
    line-height: 2;
    font-size: 16px;
    color: #333;
    padding-bottom: 28px;
    hr {
      margin-bottom: 21px;
    }
  }
}
</style>